import React from 'react'
import { useSelector } from 'react-redux'

import AboutUsSection from '../../components/about/AboutUS'
import Rimg1 from "../../assest/Residentails-1.png"
import Rimg2 from "../../assest/Residental-2.png"
import Rimg3 from "../../assest/Residenatl-3.png"
import ServicesCard from '../../components/home/ServicesCard'
import FaqSection from '../../components/about/FAQ'
import ServicesSubPages from '../residential/ServicesSubPages'

const RenovationFinishing = () => {

    const language = useSelector((state) => state.language.language) || 'gb'

    const translations = {
        gb: {
            heading: "Renovation & Finishing ",
            buttonText: "Get In Touch",
            aboutHeading: "About Our Renovation & Finishing Services",
            aboutText: `Etihad Gharbia Contracting Company delivers exceptional renovation and finishing services that transform spaces into modern, functional, and aesthetically pleasing environments. Our team of skilled craftsmen and designers work meticulously to bring your vision to life, whether it's a residential property, commercial space, or institutional facility.

We combine quality materials with precision workmanship to ensure durable and visually stunning results that exceed client expectations. From minor upgrades to complete makeovers, we handle every detail with professionalism and care.`,
            includedHeading: "Our Renovation & Finishing Solutions",
            customizedHeading: "Why Choose Our Renovation Services"
        },
        sa: {
            heading: "خدمات التجديد والتشطيب",
            buttonText: "تواصل معنا",
            aboutHeading: "حول خدمات التجديد والتشطيب",
            aboutText: `تقدم شركة اتحاد غربيا للمقاولات خدمات استثنائية للتجديد والتشطيب تحول المساحات إلى بيئات عصرية، وظيفية، وجميلة. يعمل فريقنا من الحرفيين والمصممين المهرة بدقة لتحقيق رؤيتك، سواء كانت عقارًا سكنيًا، أو مساحة تجارية، أو منشأة مؤسسية.

نجمع بين المواد عالية الجودة والإتقان في العمل لضمان نتائج متينة ومذهلة بصريًا تتجاوز توقعات العملاء. من التحديثات البسيطة إلى عمليات التغيير الكاملة، نتعامل مع كل التفاصيل باحترافية واهتمام.`,
            includedHeading: "حلولنا للتجديد والتشطيب",
            customizedHeading: "لماذا تختار خدماتنا للتجديد"
        },
        fr: {
            heading: "Services de Rénovation & Finition",
            buttonText: "Contactez-nous",
            aboutHeading: "À propos de nos services de rénovation",
            aboutText: `Etihad Gharbia Contracting Company propose des services exceptionnels de rénovation et de finition qui transforment les espaces en environnements modernes, fonctionnels et esthétiques. Notre équipe d'artisans qualifiés et de designers travaille méticuleusement pour donner vie à votre vision, qu'il s'agisse d'une propriété résidentielle, d'un espace commercial ou d'une installation institutionnelle.

Nous combinons des matériaux de qualité avec un savoir-faire précis pour garantir des résultats durables et visuellement époustouflants qui dépassent les attentes des clients. Des mises à niveau mineures aux transformations complètes, nous gérons chaque détail avec professionnalisme et soin.`,
            includedHeading: "Nos solutions de rénovation",
            customizedHeading: "Pourquoi choisir nos services"
        },
        de: {
            heading: "Renovierungs- & Fertigstellungsdienstleistungen",
            buttonText: "Kontaktieren Sie uns",
            aboutHeading: "Über unsere Renovierungsdienstleistungen",
            aboutText: `Etihad Gharbia Contracting Company bietet außergewöhnliche Renovierungs- und Fertigstellungsdienstleistungen an, die Räume in moderne, funktionale und ästhetisch ansprechende Umgebungen verwandeln. Unser Team von qualifizierten Handwerkern und Designern arbeitet akribisch daran, Ihre Vision zum Leben zu erwecken, sei es für eine Wohnimmobilie, einen Gewerberaum oder eine institutionelle Einrichtung.

Wir kombinieren qualitativ hochwertige Materialien mit präziser Handwerkskunst, um langlebige und visuell beeindruckende Ergebnisse zu erzielen, die die Erwartungen unserer Kunden übertreffen. Von kleineren Aufwertungen bis hin zu kompletten Renovierungen kümmern wir uns mit Professionalität und Sorgfalt um jedes Detail.`,
            includedHeading: "Unsere Renovierungslösungen",
            customizedHeading: "Warum unsere Dienstleistungen wählen"
        }
    }

    const t = translations[language] || translations.gb

    return (
        <>
            <AboutUsSection
                heading={t.heading}
                buttonText={t.buttonText}
                language={language}
            />
            <ServicesSubPages
                aboutHeading={t.aboutHeading}
                aboutText={t.aboutText}
                images={[Rimg1, Rimg2, Rimg3]}
                includedHeading={t.includedHeading}
                includedItems={[
                    language === 'sa' ? "الدهانات الداخلية والخارجية" : "Interior & exterior painting",
                    language === 'sa' ? "تركيب الأرضيات (سيراميك، رخام، خشب)" : "Flooring installation (tiles, marble, wood)",
                    language === 'sa' ? "تشطيبات الجدران واللمسات الزخرفية" : "Wall finishes & decorative treatments",
                    language === 'sa' ? "تصميم وتركيب الأسقف" : "Ceiling design & installation",
                    language === 'sa' ? "تحديث المطابخ والحمامات" : "Kitchen & bathroom remodeling",
                    language === 'sa' ? "استبدال الأبواب والنوافذ" : "Doors & windows replacement",
                    language === 'sa' ? "أعمال النجارة المخصصة" : "Custom carpentry & woodwork",
                    language === 'sa' ? "اللمسات النهائية وفحص الجودة" : "Final touch-ups & quality inspections"
                ]}
                customizedHeading={t.customizedHeading}
                customizedItems={[
                    language === 'sa' ? "حرفيون ذوو خبرة مع الاهتمام بالتفاصيل" : "Experienced craftsmen with attention to detail",
                    language === 'sa' ? "مواد عالية الجودة من موردين موثوقين" : "High-quality materials from trusted suppliers",
                    language === 'sa' ? "تصاميم مخصصة تناسب ذوقك" : "Customized designs to match your style",
                    language === 'sa' ? "الانتهاء في الوقت المحدد مع أقل قدر من الإزعاج" : "On-time completion with minimal disruption",
                    language === 'sa' ? "أسعار شفافة دون تكاليف خفية" : "Transparent pricing & no hidden costs",
                    language === 'sa' ? "الامتثال لأنظمة البناء السعودية" : "Compliance with Saudi building regulations",
                    language === 'sa' ? "دعم صيانة ما بعد الانتهاء" : "Post-completion maintenance support",
                    language === 'sa' ? "مديرو مشاريع مخصصون لتنفيذ سلس" : "Dedicated project managers for seamless execution"
                ]}
            />
            <ServicesCard showHeading={false} showParagraph={false} />
            <FaqSection />
        </>
    )
}

export default RenovationFinishing